import React from "react";
import "./DirectPayment.scss";

const DirectPaymentSuccess = () => {
    return (
        <div className="direct-payment">
            <div className="direct-payment-container">
                <div className="result-message success">
                    <i className="fas fa-check-circle fa-3x"></i>
                    <h2>Paiement réussi</h2>
                    <p>Votre paiement a été effectué avec succès.</p>
                    <p>Vous recevrez une confirmation par email.</p>
                    <p>Merci pour votre confiance.</p>
                </div>
            </div>
        </div>
    );
};

export default DirectPaymentSuccess;
